module.exports = __webpack_public_path__ + "static/media/process.a0f65d56.png";